import React from 'react'
import PageTitle from '../components/PageTitle'
import Link from '../components/Link'
import Layout from '../components/Layout'

const Departments = () => (
  <Layout>
    <PageTitle name="Internal Reports" site="OIRA" />

    {/* <h3>President's Office</h3> */}
    <p>The following links require UA login.</p>
    <h3><a href="https://alabama.app.box.com/file/1405628683108" target="_blank">Academic Affairs</a></h3>
    <h3><a href="https://alabama.app.box.com/file/1426346562858" target="_blank">College Reports</a></h3>
    <h3><a href="https://alabama.app.box.com/file/1883089641132" target="_blank">Enrollment Management Reports</a></h3>
    <h3><a href="https://alabama.app.box.com/file/1678797824837" target="_blank">Finance and Operations</a></h3>
    <h3><a href="https://alabama.app.box.com/file/1883124898961" target="_blank">Office of the President Reports</a></h3>
    <h3><a href="https://oira.ua.edu/soi-archive/" target="_blank">SOI Archive (Fall 2019 and before)</a></h3>
    <h3><a href="https://oiratemp.ua.edu/stat-profiles/view/majors" target="_blank">Statistical Profiles</a></h3>

  </Layout>
)

export default Departments
